import axiosInstance from "./AxiosInstance";
const token = "e532c7ba3d7dd872df0f67576c161969";

export function createRegister(formData) {
  return axiosInstance.post('/admin/addwithoutLoginPatient', formData,{skipAuth:true});
}
